import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AlertModel, ImportRowError, ImportSummary } from "../models/ProductCapabilitiesModels";

export interface ProductCapabilitiesState {
  importing: boolean;
  importResult: ImportSummary | null;
  importErrors: ImportRowError[];
  exporting: boolean;
  includeInactive: boolean;
  alert?: AlertModel;
}

const initialState: ProductCapabilitiesState = {
  importing: false,
  importResult: null,
  importErrors: [],
  exporting: false,
  includeInactive: false,
  alert: undefined,
};

export const productCapabilitiesSlice = createSlice({
  name: "productCapabilities",
  initialState,
  reducers: {
    importStarted: (state) => {
      state.importing = true;
      state.importResult = null;
      state.importErrors = [];
      state.alert = undefined;
    },
    importSucceeded: (state, action: PayloadAction<ImportSummary>) => {
      state.importing = false;
      state.importResult = action.payload;
      state.importErrors = [];
      state.alert = {
        type: "success",
        message: `Imported ${action.payload.imported} capabilities`,
      };
    },
    importRejected: (state, action: PayloadAction<ImportRowError[]>) => {
      state.importing = false;
      state.importResult = null;
      state.importErrors = action.payload;
      state.alert = {
        type: "error",
        message: `Import rejected: ${action.payload.length} row error(s)`,
      };
    },
    importFailed: (state, action: PayloadAction<string>) => {
      state.importing = false;
      state.alert = { type: "error", message: action.payload };
    },
    exportStarted: (state) => {
      state.exporting = true;
      state.alert = undefined;
    },
    exportSucceeded: (state) => {
      state.exporting = false;
    },
    exportFailed: (state, action: PayloadAction<string>) => {
      state.exporting = false;
      state.alert = { type: "error", message: action.payload };
    },
    setIncludeInactive: (state, action: PayloadAction<boolean>) => {
      state.includeInactive = action.payload;
    },
    clearAlert: (state) => {
      state.alert = undefined;
    },
  },
});
